export const calculateFinalAmount = (baseAmount, taxAmount, serviceCharge) => {
  return (baseAmount + parseFloat(taxAmount) + serviceCharge).toFixed(2);
};

export const formatCurrency = (amount) => {
  return `Rs ${parseFloat(amount).toFixed(2)}`;
};

export const formatDate = (date) => {
  return new Date(date).toLocaleString();
};

export const calculateServiceCharge = (totalAmount) => {
  if (totalAmount <= 0) return 0;
  if (totalAmount < 100) return 2;
  if (totalAmount < 500) return 3;
  if (totalAmount < 1000) return 5;
  return 10;
};